const GET_NCS_REQUEST = 'GET_NCS_REQUEST';
const GET_NCS_SUCCESS = 'GET_NCS_SUCCESS';
const GET_NCS_ERROR = 'GET_NCS_ERROR';

const DELETE_NC_REQUEST = 'DELETE_NC_REQUEST';
const DELETE_NC_SUCCESS = 'DELETE_NC_SUCCESS';
const DELETE_NC_ERROR = 'DELETE_NC_ERROR';

const CLEAR_NCS_STATE = 'CLEAR_SCANNED_DOCUMENTS_STATE';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
const INIT_REDUCER = 'INIT_REDUCER';
const CREATE_ERRORS = 'CREATE_ERRORS';

export {
  GET_NCS_REQUEST,
  GET_NCS_SUCCESS,
  GET_NCS_ERROR,
  DELETE_NC_REQUEST,
  DELETE_NC_SUCCESS,
  DELETE_NC_ERROR,
  CLEAR_NCS_STATE,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  CREATE_ERRORS,
  INIT_REDUCER,
};
